var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartsRef",staticClass:"h-full w-full overflow-hidden"})
}
var staticRenderFns = []

export { render, staticRenderFns }